export default "__VITE_ASSET__DcQgBRKK__"